import { Component, Input } from '@angular/core';
import { HisUiService } from 'hisng';
import { EmploymentClassifications } from '../../../model/classifications';

@Component({
    selector: 'psv-personprofile-edit-employment-classifications',
    templateUrl: './personprofile-edit-employment-classifications.component.html',
})
export class PersonProfileEditEmploymentClassificationsComponent {
    @Input() employmentClassifications: EmploymentClassifications[];
    
    constructor( private hisUiService: HisUiService ) {}
    
    /**
     * Besser lesbar als im Template <code>
     * [header]='ec.validTo ? ('cs.psv.person.profile.classification.employment.headerFromTo' | hisUi :ec.orgunitDefaulttext :(ec.validFrom | hisDate) :(ec.validTo | hisDate)) : ('cs.psv.person.profile.classification.employment.headerFrom' | hisUi :ec.orgunitDefaulttext :(ec.validFrom | hisDate))'
     * </code>
     */
    getFieldsetLabel(ec: EmploymentClassifications): string {
        if (ec.validTo) {
            // Wir wollen 'Beschäftigungsverhältnis an NAME DER ORGANISATIONSEINHEIT von DATUM BEGINN bis DATUM ENDE'
            return this.hisUiService.translate('cs.psv.person.profile.classification.employment.headerFromTo',
                ec.orgunitDefaulttext,
                new Date(ec.validFrom).toLocaleDateString('de-de',{year: 'numeric',month: '2-digit',day: '2-digit'}),
                new Date(ec.validTo).toLocaleDateString('de-de',{year: 'numeric',month: '2-digit',day: '2-digit'}));
        } else {
            // Wir wollen 'Beschäftigungsverhältnis an NAME DER ORGANISATIONSEINHEIT ab DATUM BEGINN'
            return this.hisUiService.translate('cs.psv.person.profile.classification.employment.headerFrom',
                ec.orgunitDefaulttext,
                new Date(ec.validFrom).toLocaleDateString('de-de',{year: 'numeric',month: '2-digit',day: '2-digit'}));
        }
    }
}
